import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-hours-input',
  templateUrl: './hours-input.component.html',
  styleUrls: ['./hours-input.component.scss'],
  standalone: false,
})
export class HoursInputComponent implements OnInit, OnChanges {
  @Input() public label: string = '';

  @Input() public hintMessage: string = '';

  @Input() public defaultTime: string = 'hh:mm';

  @Input() public format: any;

  @Input() public controlOnly: any;

  @Input() public minutesGap: any;

  @Input() public buttonAlign: 'right' | 'left' = 'right';

  @Input() public disabled: boolean = false;

  @Input() public disabled2: boolean = false;

  @Input() public useInput: boolean = false;

  @Output() public timeChanged = new EventEmitter();

  @ViewChild('timePicker', { static: false }) public timePicker: any;

  constructor() {}

  ngOnInit() {
    if (this.useInput) {
      this.disabled = false;
    }
  }

  setTime(time: string) {
    if (this.timePicker && time) {
      this.timePicker.updateTime(time);
    }
  }

  timeChangedHandler(event: any) {
    const time = typeof event === 'string' ? event : event.target.value;
    this.timeChanged.emit(time);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['defaultTime'] && this.timePicker && !this.useInput) {
      this.setTime(changes['defaultTime'].currentValue);
    }
  }
}
